import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  GET_RAW_USERS,
  GET_RAW_USERS_SUCCESS,
  GET_RAW_USERS_FAIL,
  GET_USER_DETAILS,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  GET_USER_CARTS,
  GET_USER_CARTS_SUCCESS,
  GET_USER_CARTS_FAIL,
  GET_USER_CART_DETAILS,
  GET_USER_CART_DETAILS_SUCCESS,
  GET_USER_CART_DETAILS_FAIL,
  DELETE_USER_CART,
  DELETE_USER_CART_SUCCESS,
  DELETE_USER_CART_FAIL,
  GET_USER_FAVOURITE_DETAILS,
  GET_USER_FAVOURITE_DETAILS_SUCCESS,
  GET_USER_FAVOURITE_DETAILS_FAIL,
  GET_USER_RECENT_VIEWS,
  GET_USER_RECENT_VIEWS_SUCCESS,
  GET_USER_RECENT_VIEWS_FAIL,
  DELETE_USER_FAVOURITE,
  DELETE_USER_FAVOURITE_SUCCESS,
  DELETE_USER_FAVOURITE_FAIL,
  GET_USER_ADDRESS_SUCCESS,
  GET_USER_ADDRESS,
  GET_USER_ADDRESS_FAIL,
  ADD_USER_ADDRESS,
  ADD_USER_ADDRESS_FAIL,
  ADD_USER_ADDRESS_SUCCESS,
  DELETE_USER_ADDRESS,
  DELETE_USER_ADDRESS_FAIL,
  DELETE_USER_ADDRESS_SUCCESS,
  ADD_ITEM_TO_USER_CART_SUCCESS,
  ADD_ITEM_TO_USER_CART_FAIL,
  ADD_ITEM_TO_USER_CART,
  ADD_COUPON_TO_USER_CART,
  ADD_COUPON_TO_USER_CART_FAIL,
  ADD_COUPON_TO_USER_CART_SUCCESS,
  GET_PROMOTERS,
  GET_PROMOTER_DETAILS,
  CHECK_PROMOTERID,
  DELETE_PROMOTER,
  CREATE_PROMOTER,
  UPDATE_PROMOTER,
  GET_PAGE_VIEW,
  GET_PAGE_VIEW_DETAILS,
  GET_EARINIG_DETAILS,
  GET_EARNING,
  GET_ALL_FORMATTED_EARNINGS,
  GET_PROMOTERS_FAIL,
  GET_PROMOTER_DETAILS_FAIL,
  CREATE_PROMOTER_FAIL,
  UPDATE_PROMOTER_FAIL,
  DELETE_PROMOTER_FAIL,
  CHECK_PROMOTERID_FAIL,
  GET_PAGE_VIEW_FAIL,
  GET_PAGE_VIEW_DETAILS_FAIL,
  GET_EARINIG_DETAILS_FAIL,
  GET_EARNING_FAIL,
  GET_ALL_FORMATTED_EARNINGS_FAIL,
  GET_PROMOTERS_SUCCESS,
  GET_PROMOTER_DETAILS_SUCCESS,
  CREATE_PROMOTER_SUCCESS,
  UPDATE_PROMOTER_SUCCESS,
  DELETE_PROMOTER_SUCCESS,
  CHECK_PROMOTERID_SUCCESS,
  GET_PAGE_VIEW_SUCCESS,
  GET_PAGE_VIEW_DETAILS_SUCCESS,
  GET_EARINIG_DETAILS_SUCCESS,
  GET_EARNING_SUCCESS,
  GET_ALL_FORMATTED_EARNINGS_SUCCESS,
  CREATE_USER_FAIL,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CLEAR_USER_DATA,
} from "./actionTypes"

const INIT_STATE = {
  users: [],
  rawUsers: [],
  userCarts: [],
  userCartDetails: {},
  userFavouriteDetails: {},
  userRecentViews: {},
  userAddress: [],
  addressLoad: false,
  userDetails: {},
  userVarients: {},
  error: {},
  loading: false,
  cartAddLoading: false,
  couponLoad: false,
  couponRes: {},
  createShopProductError: null,

  // promoter
  promoters: [],
  promotersList: {},
  promoterDetails: {},
  promoterLoad: false,
  promoterIdCheck: false,

  // page view
  pageView: {},
  pageViewLoading: false,
  pageViewDetails: {},

  // earning
  earningLoading: false,
  earningDetails: {},
  earnings: {},
  formattedEarnings: {},
  userCreateLoad: false,
  recentlyCreatedUser: {},
}

const Users = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS:
    case GET_RAW_USERS:
    case GET_USER_CARTS:
    case GET_USER_DETAILS:
    case GET_USER_CART_DETAILS:
    case GET_USER_FAVOURITE_DETAILS:
    case GET_USER_RECENT_VIEWS:
    case GET_RAW_USERS:
    case DELETE_USER:
    case DELETE_USER_CART:
    case DELETE_USER_FAVOURITE:
      return {
        ...state,
        loading: true,
        pageViewLoading: true,
        earningLoading: true,
      }

    //promoter
    case GET_PROMOTERS:
    case GET_PROMOTER_DETAILS:
    case CHECK_PROMOTERID:
    case DELETE_PROMOTER:
    case CREATE_PROMOTER:
    case UPDATE_PROMOTER:
    case GET_PAGE_VIEW:
    case GET_PAGE_VIEW_DETAILS:
    case GET_EARINIG_DETAILS:
    case GET_EARNING:
    case GET_ALL_FORMATTED_EARNINGS:
      return {
        ...state,
        promoterLoad: true,
        error: {},
      }

    case CREATE_USER:
      return {
        ...state,
        userCreateLoad: true,
      }
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        userCreateLoad: false,
        rawUsers: {
          users: [...state.rawUsers?.users, action.payload],
          total: state.rawUsers?.total + 1,
        },
        recentlyCreatedUser: action.payload,
      }
    case CREATE_USER_FAIL:
      return {
        ...state,
        userCreateLoad: false,
        error: action.payload,
      }
    case CLEAR_USER_DATA:
      return {
        ...state,
        recentlyCreatedUser: {},
      }
    case ADD_COUPON_TO_USER_CART:
      return {
        ...state,
        couponLoad: true,
      }
    case ADD_ITEM_TO_USER_CART:
      return {
        ...state,
        cartAddLoading: true,
      }

    case GET_USER_ADDRESS:
    case ADD_USER_ADDRESS:
    case DELETE_USER_ADDRESS:
      return {
        ...state,
        addressLoad: true,
      }

    //FAIL
    case ADD_USER_ADDRESS_FAIL:
    case GET_USER_ADDRESS_FAIL:
    case GET_USERS_FAIL:
    case GET_RAW_USERS_FAIL:
    case GET_USER_DETAILS_FAIL:
    case UPDATE_USER_FAIL:
    case GET_RAW_USERS_FAIL:
    case DELETE_USER_FAIL:
    case GET_USER_CART_DETAILS_FAIL:
    case GET_USER_CARTS_FAIL:
    case DELETE_USER_CART_FAIL:
    case DELETE_USER_CART_FAIL:
    case GET_USER_RECENT_VIEWS_FAIL:
    case GET_USER_FAVOURITE_DETAILS_FAIL:
    case DELETE_USER_FAVOURITE_FAIL:
    case DELETE_USER_ADDRESS_FAIL:
    case ADD_ITEM_TO_USER_CART_FAIL:
    // promoter

    case GET_PROMOTERS_FAIL:
    case GET_PROMOTER_DETAILS_FAIL:
    case CREATE_PROMOTER_FAIL:
    case UPDATE_PROMOTER_FAIL:
    case DELETE_PROMOTER_FAIL:
    case CHECK_PROMOTERID_FAIL:
    case GET_PAGE_VIEW_FAIL:
    case GET_PAGE_VIEW_DETAILS_FAIL:
    case GET_EARINIG_DETAILS_FAIL:
    case GET_EARNING_FAIL:
    case GET_ALL_FORMATTED_EARNINGS_FAIL:
      return {
        ...state,
        error: action.payload,
        addressLoad: false,
        loading: false,
        promoterLoad: false,
        cartAddLoading: false,
        couponLoad: false,
      }
    case ADD_COUPON_TO_USER_CART_FAIL:
      return {
        ...state,
        couponRes: action.payload,
        couponLoad: false,
      }

    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        error: {},
        loading: false,
      }

    case GET_RAW_USERS_SUCCESS:
      return {
        ...state,
        rawUsers: action.payload,
        error: {},
        loading: false,
      }

    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.payload,
        userVarients: action.payload.userVarients,
        error: {},
        loading: false,
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: {
          ...state.users,
          users: state.users.users.map(user =>
            user._id.toString() === action.payload._id.toString()
              ? { ...user, isPrime: action.payload.isPrime }
              : user
          ),
        },
        error: {},
        loading: false,
      }

    case GET_RAW_USERS_SUCCESS:
      return {
        ...state,
        rawUsers: action.payload,
        error: {},
        loading: false,
      }

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: {
          users: state?.users?.users.filter(
            user => user._id !== action.payload.id
          ),
        },
        error: {},
        loading: false,
      }

    case GET_USER_CARTS_SUCCESS:
      return {
        ...state,
        userCarts: action.payload,
        error: {},
        loading: false,
      }

    case GET_USER_CART_DETAILS_SUCCESS:
      return {
        ...state,
        userCartDetails: action.payload,
        error: {},
        loading: false,
      }

    case DELETE_USER_CART_SUCCESS:
      return {
        ...state,
        userCarts: state.userCarts.filter(
          userCart => userCart._id.toString() !== action.payload._id.toString()
        ),
        error: {},
        loading: false,
      }

    case DELETE_USER_CART_SUCCESS:
      return {
        ...state,
        userCarts: state.userCarts.filter(
          userCart => userCart._id.toString() !== action.payload._id.toString()
        ),
        loading: false,
        error: {},
      }

    case GET_USER_FAVOURITE_DETAILS_SUCCESS:
      return {
        ...state,
        error: {},
        userFavouriteDetails: action.payload,
      }

    case DELETE_USER_FAVOURITE_SUCCESS:
      return {
        ...state,
        userFavourites: state.userFavourites.filter(
          userFavourite =>
            userFavourite._id.toString() !== action.payload._id.toString()
        ),
        error: {},
        loading: false,
      }

    case GET_USER_RECENT_VIEWS_SUCCESS:
      return {
        ...state,
        error: {},
        userRecentViews: action.payload,
      }

    case GET_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        userAddress: action.payload,
        error: {},
        addressLoad: false,
      }
    case ADD_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        userAddress: action.payload,
        error: {},
        addressLoad: false,
      }
    case DELETE_USER_ADDRESS_SUCCESS:
      return {
        ...state,
        userAddress: {
          ...state.userAddress,
          shippingAddresses: state.userAddress?.shippingAddresses?.filter(
            i => i._id !== action.payload
          ),
        },
        addressLoad: false,
        error: {},
      }

    case ADD_ITEM_TO_USER_CART_SUCCESS:
      return {
        ...state,
        userCartDetails: action.payload,
        error: {},
        cartAddLoading: false,
      }

    case ADD_COUPON_TO_USER_CART_SUCCESS:
      return {
        ...state,
        couponRes: action.payload,
        error: {},
        couponLoad: false,
      }

    // promoter
    case GET_PROMOTERS_SUCCESS:
      return {
        ...state,
        promotersList: action.payload,
        promoterLoad: false,
        error: {},
      }
    case GET_PROMOTER_DETAILS_SUCCESS:
      return {
        ...state,
        promoterDetails: action.payload,
        promoterLoad: false,
      }
    case CREATE_PROMOTER_SUCCESS:
      return {
        ...state,
        promoterDetails: action.payload,
        promoterLoad: false,
      }
    case UPDATE_PROMOTER_SUCCESS:
      return {
        ...state,
        promoterDetails: action.payload,
        promoterLoad: false,
        loading: false,
        promotersList: {
          ...state.promotersList,
          promoters:
            action?.payload?.sort === "active" ||
            action?.payload?.sort === "inactive"
              ? state.promotersList?.promoters?.filter(
                  list => list._id !== action.payload._id
                )
              : state.promotersList?.promoters?.map(list =>
                  list?._id === action.payload?._id
                    ? { ...list, isActive: action.payload.isActive }
                    : list
                ),
        },
      }
    case DELETE_PROMOTER_SUCCESS:
      return {
        ...state,
        promoters: action.payload,
        promoterLoad: false,
      }
    case CHECK_PROMOTERID_SUCCESS:
      return {
        ...state,
        promoterIdCheck: action.payload,
        promoterLoad: false,
        loading: false,
      }
    case GET_PAGE_VIEW_SUCCESS:
      return {
        ...state,
        pageView: action.payload,
        pageViewLoading: false,
      }
    case GET_PAGE_VIEW_DETAILS_SUCCESS:
      return {
        ...state,
        pageViewDetails: action.payload,
        pageViewLoading: false,
      }
    // All Earnings Details

    case GET_EARINIG_DETAILS_SUCCESS:
      return {
        ...state,
        earningDetails: action.payload,
        earningLoading: false,
      }
    // All Earnings
    case GET_EARNING_SUCCESS:
      return {
        ...state,
        earnings: action.payload,
        earningLoading: false,
      }
    case GET_ALL_FORMATTED_EARNINGS_SUCCESS:
      return {
        ...state,
        formattedEarnings: action.payload,
        earningLoading: false,
      }

    default:
      return state
  }
}

export default Users
